import { useEffect, useState } from 'react';
import { fetchModuleStatuses } from "../modules/onboarding/core/_requests"

// Define a type for the module statuses
interface ModuleStatuses {
  [key: string]: boolean;
}

export const useModuleStatus = () => {
  // Use the defined type for the state
  const [moduleStatus, setModuleStatus] = useState<ModuleStatuses>({});

  useEffect(() => {
    const getModuleStatus = async () => {
      try {
        const { data } = await fetchModuleStatuses();
        if (data.success) {
          setModuleStatus(data.data);
        }
      } catch (err) {
        console.error('Error fetching module statuses:', err);
      }
    };

    getModuleStatus();
  }, []);

  return { moduleStatus };
};

